export interface ApiAccountType {
  id: string;
  name: string;
}

export interface SlackChannelType {
  id: string;
  name: string;
}

export interface AlarmRuleType {
  id: string;
  account: string;
  event_type: string;
  slack_channel_id: string;
  slack_channel_name: string;
  enabled: boolean;
}

export interface PaginatedResponseType<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const ALARM_EVENT_TYPES = [{ value: 'message_sent_outbound', label: 'Message Sent' }];
